<template>
    <div class="MuiAutocomplete-root MuiAutocomplete-hasClearIcon css-d1kud3">
        <div class="MuiFormControl-root MuiFormControl-fullWidth MuiTextField-root css-x4yv5h">
            <label
                :class="focus || val ? 'css-1448in2' : ''"
                class="MuiFormLabel-root MuiInputLabel-root MuiInputLabel-formControl MuiInputLabel-animated MuiInputLabel-filled MuiFormLabel-colorPrimary MuiInputLabel-root MuiInputLabel-formControl MuiInputLabel-animated MuiInputLabel-filled css-1veqoqp"
                data-shrink="false" for="industryType" id="industryType-label">{{ label }}</label>
            <div :class="element == 'textarea' ? 'textarea-block' : ''" class="MuiInputBase-root MuiFilledInput-root MuiFilledInput-underline MuiInputBase-colorPrimary MuiInputBase-fullWidth MuiInputBase-formControl MuiInputBase-adornedEnd MuiAutocomplete-inputRoot css-qvr393">
                <input
                    v-if="element == 'input'"
                    @focus="focus = true"
                    @blur="focus = false"
                    v-model="val"
                    :id="id_c"
                    :type="type"
                    class="MuiInputBase-input MuiFilledInput-input MuiInputBase-inputAdornedEnd MuiAutocomplete-input MuiAutocomplete-inputFocused css-ftr4jk">
                <textarea
                    v-if="element == 'textarea'"
                    @focus="focus = true"
                    @blur="focus = false"
                    v-model="val"
                    rows="3"
                    :id="id_c"
                    class="textarea-c MuiInputBase-input MuiFilledInput-input MuiInputBase-inputAdornedEnd MuiAutocomplete-input MuiAutocomplete-inputFocused css-ftr4jk"></textarea>
            </div>
            <p v-if="is_error" class="sc-dPwPAC iFySEt MuiTypography-root MuiTypography-body1 sc-eGbavc eypHHc">{{ text_error }}</p>
        </div>
    </div>
</template>
<script>
	export default {
	    props: {
            id_c: String,
            is_error: String,
            text_error: String,
            label: String,
            modelValue: String,
            element: {
                type: String,
                default: 'input'
            },
            type: {
                type: String,
                default: 'text'
            }
        },
        data() {
	      return {
              focus: false
          }
        },
        methods: {

        },
        computed: {
            val: {
                get() {
                    return this.modelValue
                },
                set(val) {
                    this.$emit('update:modelValue', val)
                }
            }
        }
	}
</script>
<style>
.MuiInputBase-input_type_date {
    padding-top: 14px!important;
}
</style>
